import { fetchAuthSession } from "aws-amplify/auth";
import { sanitizeAttachedFiles } from "@amzn/afxtaco-utilities";

interface PingMessageParams {
  projectId: string;
  sessionId: string;
  clientRequestId: string;
  prompt: string;
  initAction: string;
  isProjectNew?: boolean;
  attachedFiles?: { name: string; s3Key: string }[];
  /**
   * SFDC IDs recorded on this project. Sent on every turn so the agent knows
   * which customer to work with without being told again.
   */
  customerContext?: {
    accountIds?: string[];
    opportunityIds?: string[];
  };
}

export async function buildPingMessage(
  params: PingMessageParams,
): Promise<string> {
  const session = await fetchAuthSession();
  const accessToken = session.tokens?.accessToken?.toString();
  if (!accessToken) {
    throw new Error("Authentication session expired. Please refresh the page.");
  }

  const { attachedFiles, customerContext, ...restParams } = params;

  let validatedFiles;
  if (attachedFiles) {
    validatedFiles = sanitizeAttachedFiles(attachedFiles);
  }

  return JSON.stringify({
    action: "ping",
    ...restParams,
    agentPayload: {
      accessToken: accessToken,
      attachedFiles: validatedFiles,
      // Omitted entirely when no customer is linked, so the agent can treat
      // presence as meaningful.
      ...(customerContext ? { customerContext } : {}),
    },
  });
}
